import { render, staticRenderFns } from "./partsTableExpand.vue?vue&type=template&id=0ed206e2&scoped=true&"
import script from "./partsTableExpand.vue?vue&type=script&lang=js&"
export * from "./partsTableExpand.vue?vue&type=script&lang=js&"
import style0 from "./partsTableExpand.vue?vue&type=style&index=0&id=0ed206e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed206e2",
  null
  
)

export default component.exports